module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"block\">\r\n    <h2 id=\"test\">OAuth 2 Connection Parameters</h2>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-4\">\r\n            <img id=\"getToken\" style=\"cursor:pointer;width:185px;\" src=\"")
    ; __append( require('manager/buttons/btn_google_signin_light_normal_web.png') )
    ; __append("\"/>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <span>Account</span>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n            <input type=\"text\" class=\"connection\" name=\"_username\" id=\"googleAccount\" readonly value=\"")
    ; __append(escapeFn( currentConnectionDetails.ConnectionXML.Connection['_username'] ))
    ; __append("\"/>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3\"><label>Status</label></div>\r\n        <div class=\"col-md-9\"><input type=\"text\" name=\"Status\" readonly id=\"googleConStatus\" value=\"")
    ; __append(escapeFn( currentConnectionDetails.ConnectionXML.Connection['_status'] ))
    ; __append("\" />\r\n    </div>\r\n \r\n   \r\n\r\n    <h2 id=\"test\">Google Sheets</h2>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <button id=\"loadFilePicker\" ")
    ;  if(currentConnectionDetails.ConnectionXML.Connection['_status'] !== "Connected"){ 
    ; __append(" disabled ")
    ;  } 
    ; __append("class=\"btn btn-default\">\r\n                ")
    ;  if(currentConnectionDetails.ConnectionXML.Connection['_fileName'] === ""){ 
    ; __append(" Select ")
    ;  } else{
    ; __append("Change ")
    ;  } 
    ; __append(" Sheet</button>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <span>File Name</span>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n            <input type=\"text\" name=\"fileName\"  readonly id=\"googleFileName\" value=\"")
    ; __append(escapeFn( currentConnectionDetails.ConnectionXML.Connection['_fileName'] ))
    ; __append("\" />\r\n            \r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <span>Sheet Name</span>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n            <select id=\"spreadSheet\" name=\"_spreadsheet\" readonly>\r\n               ")
    ;  if(currentConnectionDetails.ConnectionXML.Connection["_spreadsheet"] !== '' && spreadSheets.length === 0){
    ; __append("\r\n                   <option value=\"")
    ; __append(escapeFn(currentConnectionDetails.ConnectionXML.Connection['_spreadsheet']))
    ; __append("\">")
    ; __append(escapeFn(currentConnectionDetails.ConnectionXML.Connection['_spreadsheet']))
    ; __append("</option>\r\n               ")
    ; } else { 
    ; __append("\r\n                        ")
    ; spreadSheets.map(function(spreadSheet){
    ; __append("\r\n                        <option value=\"")
    ; __append(escapeFn(spreadSheet['@name']))
    ; __append("\" ")
    ; __append(escapeFn( currentConnectionDetails.ConnectionXML.Connection["_spreadsheet"] === spreadSheet['@name'] ? 'selected' : '' ))
    ; __append(">")
    ; __append(escapeFn(spreadSheet['@name']))
    ; __append("</option>\r\n                    ")
    ;  });
                  }
    ; __append(" \r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div id=\"loading\">\r\n    <div id=\"loading-div\" class=\"ui-corner-all\" style=\"width: 400px;padding: 40px;\">\r\n    <h4 style=\"font-weight:normal;text-align: center; margin-bottom:20px;\"></h4>\r\n    <img src=\"")
    ; __append( require('loadingIndicator.gif') )
    ; __append("\" alt=\"Loading..\"/>\r\n	</div>\r\n</div>")
  }
  return __output;

}